import isUndefined from "lodash/isUndefined";
import { Select, SelectProps } from "PFComponents/select";
import { PureCustomValue } from "PFTypes";
import { Option } from "PFTypes/options";

import { ValuesList } from "./values_list";

export type OptionOriginal = PureCustomValue & {
  expiryDate?: string | null;
};

export type CustomValueOption = Option<OptionOriginal>;

export type CustomValueSelectProps = SelectProps<OptionOriginal> & {
  onDateChange?: (option: Option<OptionOriginal>) => void;
  withExpiryDate?: boolean;
  displayValues?: React.ReactNode | null;
};

export const CustomValueSelect = (props: CustomValueSelectProps) => {
  const {
    multiple,
    onChange,
    onDateChange,
    onClear,
    withExpiryDate,
    displayValues,
    disabled,
    locked,
    tabIndex
  } = props;

  const formatSelectedOptions = (selectedOptions: CustomValueOption | CustomValueOption[]) =>
    Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];

  const renderDisplayValue = (selectedOptions) =>
    isUndefined(displayValues) ? (
      <ValuesList
        selectedOptions={formatSelectedOptions(selectedOptions || [])}
        onChange={onChange}
        onClear={onClear}
        onDateChange={onDateChange}
        withExpiryDate={withExpiryDate}
        multiple={multiple}
        disabled={disabled || locked}
        tabIndex={tabIndex}
      />
    ) : (
      displayValues
    );

  return <Select<OptionOriginal> {...props} renderDisplayValue={renderDisplayValue} />;
};
